import React, {useEffect, useState, useContext} from 'react';
import styled from "styled-components";
import {PropertiesContext, PropertiesDispatcherContext} from "@providers/properties";
import {getSimilarProperties} from "@models/property";
import useTrans from "@hooks/translation";
import {useRouter} from "next/router";
import {isEmpty} from "../../helpers/helpers";
import SwiperPropertiesCard from "./swiper_properties_card";

/**
 * @return {null}
 */
function SimilarProperties({property, className, isBadeSaba = false}) {
    const router = useRouter();
    const properties_dispatcher = useContext(PropertiesDispatcherContext);
    const [similarProperties, setSimilarProperties] = useState([]);
    const properties_context = useContext(PropertiesContext);
    const [showSkeleton, setShowSkeleton] = useState(true);

    useEffect(() => {
        getSimilarProperties(property.id).then(result => {
            setSimilarProperties(result.properties);
            setShowSkeleton(false);
        }).catch(err => {
            console.log(err)
        })
    }, [property]);

    useEffect(() => {
        if (!isEmpty(properties_context.pushState)) {
            if (properties_context.pushState.loading && !properties_context.pushState.back) {
                router.push(properties_context.pushState.href, properties_context.pushState.link);
            }
        }
    }, [properties_context]);

    const handleShowProperty = (e, link, media = 0) => {
        e.preventDefault();
        e.stopPropagation();

        properties_dispatcher({
            type: 'PUSH_STATE',
            payload: {
                link: link,
                href: '/properties/show',
                media: (media > 5) ? 5 : media,
                loading: true,
                offsetTop: window.pageYOffset + 1,
                back: false,
                isBadeSaba: isBadeSaba
            }
        })
    };

    if (showSkeleton || similarProperties.length > 0) {
        return (
            <Similar className={(className ? className : '')}>
                <h2 className="mb-24 mr-24 mr-lg-0">
                    {useTrans('type.' + property.type)}‌های مشابه برای {useTrans('deal_type.' + property.deal_type)}
                </h2>

                <SwiperPropertiesCard
                    freeMode={false}
                    cartClassName="js-track-similar-property"
                    properties={similarProperties}
                    handleShowProperty={handleShowProperty}
                    isBadeSaba={isBadeSaba}
                />
            </Similar>
        )
    } else {
        return '';
    }
}

export default React.memo(SimilarProperties);

const Similar = styled.div`
    .swiper-button-prev,
    .swiper-button-next {
        top: 126px;
    }
`;
